import React, { useState, useEffect } from 'react';

function Nulls() {
  return <span style={{ color:'#777', fontWeight:'400', fontSize:'13px' }}>Not Specified</span>
}

export default Nulls;
